/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayPlayerMetricsDtoSchema } from "./goodLuck/core/DTOs/replayPlayerMetricsDtoSchema.ts";
import { microsoftAspNetCoreMvcProblemDetailsSchema } from "./microsoft/aspNetCore/mvc/problemDetailsSchema.ts";
import { z } from "zod/v4";

export const getTournamentsTournamentidReplayMetricsPathParamsSchema = z.object(
  {
    tournamentId: z.string(),
  },
);

/**
 * @description OK
 */
export const getTournamentsTournamentidReplayMetrics200Schema = z.array(
  z.lazy(() => goodLuckCoreDTOsReplayPlayerMetricsDtoSchema),
);

/**
 * @description Not Found
 */
export const getTournamentsTournamentidReplayMetrics404Schema = z.lazy(
  () => microsoftAspNetCoreMvcProblemDetailsSchema,
);

export const getTournamentsTournamentidReplayMetricsQueryResponseSchema =
  getTournamentsTournamentidReplayMetrics200Schema;
